__turbopack_context__.v({
  "blocksBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__blocksBackgroundColor",
  "blocksFontColor": "PageIndexPage-module-scss-module__JaKBAG__blocksFontColor",
  "bulkBarSticky": "PageIndexPage-module-scss-module__JaKBAG__bulkBarSticky",
  "categoryBadgeIcon": "PageIndexPage-module-scss-module__JaKBAG__categoryBadgeIcon",
  "container": "PageIndexPage-module-scss-module__JaKBAG__container",
  "filterChip": "PageIndexPage-module-scss-module__JaKBAG__filterChip",
  "hoverPreviewContent": "PageIndexPage-module-scss-module__JaKBAG__hoverPreviewContent",
  "hoverPreviewTrigger": "PageIndexPage-module-scss-module__JaKBAG__hoverPreviewTrigger",
  "letterButton": "PageIndexPage-module-scss-module__JaKBAG__letterButton",
  "letterHeader": "PageIndexPage-module-scss-module__JaKBAG__letterHeader",
  "list": "PageIndexPage-module-scss-module__JaKBAG__list",
  "loadMoreTrigger": "PageIndexPage-module-scss-module__JaKBAG__loadMoreTrigger",
  "mainContent": "PageIndexPage-module-scss-module__JaKBAG__mainContent",
  "secondaryNavBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__secondaryNavBackgroundColor",
  "selectableRow": "PageIndexPage-module-scss-module__JaKBAG__selectableRow",
  "selectedRow": "PageIndexPage-module-scss-module__JaKBAG__selectedRow",
  "sidebarDesktop": "PageIndexPage-module-scss-module__JaKBAG__sidebarDesktop",
  "themeBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__themeBackgroundColor",
  "themeFontColor": "PageIndexPage-module-scss-module__JaKBAG__themeFontColor",
});
